import FieldType from '../../components/Form/Fields/type'
import { lengthRequired } from '@polvo-labs/form-utils'
import Password from '../../components/Form/Fields/Password'

export interface DisableFormData {
  password: string
}

export type DisableForm = keyof DisableFormData

const fields: FieldType<DisableForm>[] = [
  {
    name: 'password',
    component: Password,
    data: {
      icon: 'password',
      label: '',
    },
    html: {
      placeholder: 'Digite sua senha',
    },
    validation: lengthRequired({ min: 0, max: 255 }),
  },
]

export default fields
